export const formatCoberturaLabel = (cobertura) => {
  if (!cobertura) return "";
  if (cobertura.label) return cobertura.label;
  return `${cobertura.id} - ${cobertura.nombre || cobertura.cobertura || ""}`;
};

export const formatMedicoLabel = (medico) => {
  if (!medico) return "";
  return `${medico.codigo} - ${medico.nombre || medico.descripcion || ""} - ${medico.especialidad || medico.descripcionEspecialidad || ""}`;
};

export const buildSearchParams = (searchTerm, isCobertura) => {
  const trimmedTerm = searchTerm.trim();
  if (!trimmedTerm) return null;

  const isNumber = /^\d+$/.test(trimmedTerm);

  if (isCobertura) {
    return {
      ...(isNumber ? { cobertura: trimmedTerm } : { nombreCobertura: trimmedTerm }),
      servicio: 2,
    };
  }

  return isNumber
    ? { codigoMedico: trimmedTerm }
    : { nombreMedico: trimmedTerm };
};

export const buildCoberturaOption = (procedimiento) => ({
  value: procedimiento.id,
  label: `${procedimiento.cobertura} - ${procedimiento.nombreCobertura}`,
  ...procedimiento,
});

export const buildMedicoOption = (medico) => ({
  value: medico.codigo,
  label: `${medico.codigo} - ${medico.nombre || medico.descripcion || ""} - ${medico.especialidad || medico.descripcionEspecialidad || ""}`,
  ...medico,
  nombre: medico.nombre || medico.descripcion || "",
  especialidad: medico.especialidad || medico.descripcionEspecialidad || "",
});

export const buildEspecialidadOption = (item) => ({
  value: item.codigo?.toString() || "",
  label: item.descripcion || "",
  especialidad: item.descripcion || "",
  codigoEspecialidad: item.codigo?.toString() || "",
});

export const isMedicoCompatible = (medico, coberturaId, obtenerMedicosDisponibles) => {
  if (!medico || !coberturaId) return false;
  const medicosDisponibles = obtenerMedicosDisponibles(coberturaId);
  return medicosDisponibles.some((med) => med.codigo === medico.codigo);
};

export const removeSearchTerm = (searchTerms, itemId) => {
  const newState = { ...searchTerms };
  delete newState[itemId];
  return newState;
};

export const updateSearchTerm = (searchTerms, itemId, value) => ({
  ...searchTerms,
  [itemId]: value,
});

